import "react-quill/dist/quill.snow.css";
import styles from "./PageEdit.module.css"

// component
import TextInput from "./TextInput";

/**
 * A reusable section editor component.
 *
 * @param {bool} setImage - Display thee ability to set an image for the section.
 * @param {string} sectionKey - The section key (e.g., "Sec1", "PageHeader"), used as key in the json data.
 * @param {string} header - The section header text.
 * @param {string} text - The section text.
 * @param {string} image - The section image URL.
 * @param {Function} updateField - Function to update the parent state.
 *
 * @example
 * <PageInfoEdit setImage={True} sectionKey="Sec1" header={data.Sec1.header} updateField={updateField} />
 */

export default function SimpleInfoEdit({parentSectionKey, sectionKey, header, text, when, id, link, updateField}) {


    return(
        <div className={styles.pageInfoEdit}>
             <h2>{header}</h2>

            {/* Header Input */}
            <TextInput
                label={"Header:"}
                value={header}
                onChange={(e) => updateField(parentSectionKey, sectionKey+".header", e.target.value)}
            />

            {/* Content id */}
            <TextInput
                label={"Id:"}
                value={id}
                onChange={(e) => updateField(parentSectionKey, sectionKey+".id", e.target.value)}
            />

            {/* text */}
            <TextInput
                label={"Tekst:"}
                value={text}
                onChange={(e) => updateField(parentSectionKey, sectionKey+".text", e.target.value)}
            />

            {/* when */}
            <TextInput
                label={"Hvornår:"}
                value={when}
                onChange={(e) => updateField(parentSectionKey, sectionKey+".when", e.target.value)}
            />

            {/* link */}
            <TextInput
                label={"link:"}
                value={link}
                onChange={(e) => updateField(parentSectionKey, sectionKey+".link", e.target.value)}
            />

        </div>
    );

}